// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';
import flashMessage from '../../../utils/flashMessage';

export default class IndexView extends JQueryView {
  constructor() {
    super('.important_meetings.index');

    $('.showMore').on('click', e => {
      e.stopPropagation();
      $(e.target)
        .closest('.summary')
        .hide();
      $(e.target)
        .closest('td')
        .find('.details')
        .show();
    });

    $('.showLess').on('click', e => {
      e.stopPropagation();
      $(e.target)
        .closest('.details')
        .hide();
      $(e.target)
        .closest('td')
        .find('.summary')
        .show();
    });
  }

  @on({ event: 'click', selector: '.copy-share-link' })
  copyToClipboard(e: any) {
    const shareLink = e.currentTarget.dataset.link;
    if (shareLink) {
      navigator.clipboard.writeText(shareLink);
      flashMessage('共有リンクをコピーしました', 'success');
    } else {
      flashMessage(
        '共有リンクをコピーできませんでした。再度お試しください。',
        'error',
      );
    }
  }
}
